import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { registerSocket, deregisterSocket } from 'services/socket';
import _ from 'lodash';

import MenuAlert from './menu-alert';


class ExpenseMenuAlert extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    registerSocket('purchaseOrderStatus', (message) => {
      this.setState({ expenseAlert: message });
    });
  }
  
  componentWillUnmount() {
    deregisterSocket('purchaseOrderStatus');
  }

  render() {
    const { currentUser } = this.props;
    const { expenseAlert } = this.state;

    const totalExpensesNeedAttention = getNumberExpensesNeedAttention(expenseAlert, currentUser);

    if (totalExpensesNeedAttention <= 0) return null;

    return (
      <MenuAlert
        title={'There are purchases which need your attention'}
        className={`badge-${getBadgeType(expenseAlert, currentUser)}`}
      >
        {totalExpensesNeedAttention}
      </MenuAlert>
    );
  }
}

export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(ExpenseMenuAlert);


// Internal helper functions
function getBadgeType(expenseAlert, currentUser) {
  if (!expenseAlert || !currentUser) return;

  if (expenseAlert.unassigned) return 'danger';
  if ((expenseAlert[currentUser.id] || {}).unapproved) return 'warning';
  if ((expenseAlert[currentUser.id] || {}).unbilled) return 'info';
}

function getNumberExpensesNeedAttention(expenseAlert, currentUser) {
  if (!expenseAlert || !currentUser) return;

  return _.sum([
    (expenseAlert[currentUser.id] || {}).unbilled,
    (expenseAlert[currentUser.id] || {}).unapproved,
    expenseAlert.unassigned
  ]);
}



// WEBPACK FOOTER //
// ./app/components/main-menu/components/expense-menu-alert.js